var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',[_c('m-custom-form-control')],1),_c('m-global-spinner'),_c('m-global-snackbar'),_c('m-global-alert'),_c('m-global-confirm'),_c('m-global-prompt')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }